/***** Code Mapping *****/
//List of products: spbSdk (txn_rcvd_brandedxoec_count_6mt), spbButton (txn_rcvd_brandedxoec_count_6mt), spbDev, subscriptionsHawk, subscriptionsApi, subscriptionsDev, pph, ppme, invoicingHawk, invoicingApi, invoicingDev, vt, ucc, uccDev, ppShopping, ppInsights, addDeveloper, apiCredentials, partners, marketplaces

export const quizOptionsCountryFilter = {
  cardReader: ['IT', 'ES']
};

export const quizResultsCountryFilter = {
  marketplaces: ['FR', 'IT', 'ES']
};

export const productFilterMHNS = {
  spbSdk: 'pp_express_checkout',
  spbButton: 'pp_buttons',
  spbDev: 'pp_express_checkout',
  pph: 'pp_here',
  ppme: 'pp_me',
  vt: 'pp_virtual_terminal',
  ucc: {
    rpsKey: 'last_6_mnth_ucc_rcvd_y_n'
  },
  uccDev: {
    rpsKey: 'last_6_mnth_ucc_rcvd_y_n'
  },
  ppInsights: 'pp_shopper_insights'
};

export const optionsToProductMapping = {
  goods: ['spbButton', 'subscriptionsHawk', 'ppme'],
  services: ['ppme', 'invoicingHawk'],
  other: ['ppme'],
  notSelling: ['ppme', 'partners', 'marketplaces'],
  marketplace: ['ppme', 'marketplaces'],
  paymentsWebApp: ['ppShopping', 'ppInsights'],
  link: ['ppme'],
  cardReader: ['pph'],
  invoiceOrEstimate: ['invoicingHawk'],
  phone: ['vt'],
  singleTransaction: [
    'spbSdk',
    'spbButton',
    'spbDev',
    'invoicingApi',
    'invoicingDev',
    'partners',
    'marketplaces',
    'ucc',
    'addDeveloper',
    'apiCredentials'
  ],
  recurring: [
    'subscriptionsHawk',
    'subscriptionsApi',
    'subscriptionsDev',
    'invoicingApi',
    'invoicingDev',
    'partners',
    'marketplaces',
    'addDeveloper',
    'apiCredentials'
  ],
  prebuilt: [
    'spbButton',
    'subscriptionsHawk',
    'partners',
    'marketplaces',
    'addDeveloper',
    'apiCredentials'
  ],
  custom: [
    'spbSdk',
    'subscriptionsApi',
    'invoicingApi',
    'addDeveloper',
    'apiCredentials'
  ],
  developer: [
    'spbDev',
    'subscriptionsDev',
    'invoicingDev',
    'uccDev',
    'apiCredentials'
  ],
  extras: ['addDeveloper', 'apiCredentials', 'partners', 'marketplaces']
};

export const optionsMapping = {
  step1: ['goods', 'services', 'other', 'notSelling'],
  step2: [
    'paymentsWebApp',
    'marketplace',
    'invoiceOrEstimate',
    'cardReader',
    'phone',
    'link'
  ],
  step3: ['singleTransaction', 'recurring'],
  step4: ['prebuilt', 'custom', 'developer']
};

export const linkToExtraProductMapping = {
  restart: '/merchantapps/appcenter',
  partners: '/merchantapps/appcenter/partners',
  marketplaces: '/merchantapps/appcenter/marketplaces',
  addDeveloper: '/commercesetup/addDeveloper',
  apiCredentials: '/commercesetup/APICredentials?guided=true'
};

export const toolsFilterMapping = {
  spbSdk: 'pp_express_checkout',
  spbButton: 'pp_buttons',
  spbDev: 'pp_express_checkout',
  subscriptionsHawk: 'pp_subscriptions_v1',
  subscriptionsApi: 'pp_subscriptions_v1',
  subscriptionsDev: 'pp_subscriptions_v1',
  pph: 'pp_here',
  invoicingHawk: 'pp_invoicing',
  invoicingApi: 'pp_invoicing',
  invoicingDev: 'pp_invoicing',
  vt: 'pp_virtual_terminal',
  ucc: 'pp_express_checkout',
  uccDev: 'pp_express_checkout',
  ppShopping: 'pp_store_cash',
  ppInsights: 'pp_shopper_insights'
};

export const productToRPSMapping = {
  spbSdk: 'ppcp_ec',
  spbButton: 'ppcp_ec_spb',
  spbDev: 'ppcp_ec_dev',
  subscriptionsHawk: 'ppcp_subscriptions',
  subscriptionsApi: 'ppcp_subscriptions_api',
  subscriptionsDev: 'ppcp_subscriptions_dev',
  pph: 'ppcp_pph',
  ppme: 'ppcp_ppme',
  invoicingHawk: 'ppcp_invoice',
  invoicingApi: 'ppcp_invoice_api',
  invoicingDev: 'ppcp_invoice_dev',
  vt: 'ppcp_vt',
  ucc: 'ppcp_ucc',
  uccDev: 'ppcp_ucc_dev',
  ppShopping: 'ppcp_storecash',
  ppInsights: 'ppcp_insights',
  wooSpbManual: 'ppcp_woocommerce_spb',
  wooSpbConnect: 'ppcp_woocommerce_connect',
  ppdg: 'ppcp_digital_giftcard',
  qrcode: 'ppcp_qrcode',
  izettle: 'ppcp_izettle'
};

export const linkToProductMapping = {
  spbSdk: '/merchantapps/appcenter/acceptpayments/checkout#details-options-2',
  spbButton:
    '/merchantapps/appcenter/acceptpayments/checkout#details-options-1',
  spbDev: '/merchantapps/appcenter/acceptpayments/checkout#details-cta',
  subscriptionsHawk: '/merchantapps/appcenter/acceptpayments/subscriptions',
  subscriptionsApi: '/merchantapps/appcenter/acceptpayments/subscriptions',
  subscriptionsDev: '/merchantapps/appcenter/acceptpayments/subscriptions',
  pph: '/merchantapps/appcenter/acceptpayments/paypalhere',
  ppme: '/merchantapps/appcenter/acceptpayments/paypalme',
  invoicingHawk: '/merchantapps/appcenter/acceptpayments/invoicing',
  invoicingApi: '/merchantapps/appcenter/acceptpayments/invoicing',
  invoicingDev: '/merchantapps/appcenter/acceptpayments/invoicing',
  vt: '/merchantapps/appcenter/acceptpayments/virtualterminal',
  ucc: '/merchantapps/appcenter/acceptpayments/checkout#details-options-3',
  uccDev: '/merchantapps/appcenter/acceptpayments/checkout#details-options-3',
  ppShopping: '/merchantapps/appcenter/accelerategrowth/storecash',
  ppInsights: '/merchantapps/appcenter/accelerategrowth/shopperinsights'
};

export const productsToIconMapping = {
  spbSdk: 'cart',
  spbButton: 'buttons',
  spbDev: 'cart',
  subscriptionsHawk: 'recurring',
  subscriptionsApi: 'recurring',
  subscriptionsDev: 'recurring',
  pph: 'pp-logo', //TODO: Default icon for now update to correct one
  ppme: 'contact-info',
  invoicingHawk: 'invoice',
  invoicingApi: 'invoice',
  invoicingDev: 'invoice',
  vt: 'phone',
  ucc: 'cart',
  uccDev: 'cart ',
  ppShopping: 'special-financing',
  ppInsights: 'insights'
};

/***** FPTI Mapping *****/
export const optionsToFPTIMapping = {
  step1: {
    goods: 'goods',
    services: 'services',
    other: 'other',
    notSelling: 'you_are_not_selling'
  },
  step2: {
    paymentsWebApp: 'payment_on_website',
    marketplace: 'on_marketplace',
    invoiceOrEstimate: 'send_invoice_or_estimates',
    cardReader: 'use_card_reader',
    phone: 'collect_credit_card_info',
    link: 'create_link_to_accept_payments'
  },
  step3: {
    singleTransaction: 'single_transaction',
    recurring: 'subscribe_recurring_basis'
  },
  step4: {
    prebuilt: 'prebuild_solution',
    custom: 'custom_solution',
    developer: 'developer'
  },
  step5: {}
};

export const stepPageFPTI = {
  step1: 'what_do_you_sell',
  step2: 'how_would_you_like_to_sell',
  step3: 'how_customer_purchase_products',
  step4: 'type_of_setup_experience'
};

export const productsToFPTIMapping = {
  spbSdk: 'checkout',
  spbButton: 'buttons',
  spbDev: 'checkout:dev',
  subscriptionsHawk: 'subscriptions',
  subscriptionsApi: 'subscriptions:api',
  subscriptionsDev: 'subscriptions:dev',
  pph: 'pph',
  ppme: 'paypal_me',
  invoicingHawk: 'invoicing',
  invoicingApi: 'invoicing:api',
  invoicingDev: 'invoicing:dev',
  vt: 'virtual_terminal',
  ucc: 'ucc',
  uccDev: 'ucc:dev',
  ppInsights: 'shopper_insights',
  ppShopping: 'store_cash'
};

export const extraCardToFPTIMapping = {
  restart: 'go_to_our_app_center',
  partners: 'partners',
  marketplaces: 'sell_on_marketplace',
  addDeveloper: 'invite_developer',
  apiCredentials: 'get_your_credentials'
};

export const productCountryVariations = {
  pph: {
    rpsKey: 'izettle',
    countries: ['FR', 'GB']
  }
};
